export default __webpack_public_path__ + "static/media/64_mobile.5d5dee48.jpg";